

export function alphabetically_asc ( a: string, b: string )
{
  return a > b? 1 : a < b? -1 : 0 ;
}


export function numerically_asc ( a: number, b: number )
{
  return a - b ;
}


export class CodeError extends Error
{
  code: number ;

  constructor ( code: number, msg: string = '' )
  {
    super( msg ) ;

    this.code = code ;
  }

  get msg ( ) { return this.message } ;
}